import React, { useState, useEffect, useRef } from "react";
import userapiservice from "../../api/userapiservice";
import { getRequest } from "../../api/http";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  useMap,
  ZoomControl,
  Tooltip,
} from "react-leaflet";
import { Button } from "antd";
import "./MapComponent.scss";
import L from "leaflet";
import locateMe from "../../assets/images/locateMe.png";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import { setLang, setLat } from "../../Reducer/localStorageSlice";
import { useSelector, useDispatch } from "react-redux";
import LocationMarker from "./Map/LocationMarker";
import MyComponent from "./Map/Mycomponent";
import { getMarkerByIndex } from "./Map/getMarkerByIndex";

export default function MapComponent({
  radiusValue,
  ChangeRadiusHandler,
  markerData,
  selectedOrg,
  activeMiniPopup,
  allowSetView = false,
  disableSetView,
  cancelClick,
  updateCancelClick,
}) {
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const markerRefs = useRef({});
  const mapRef = useRef({});

  const localData = useSelector((state) => state?.localStorage)
  const { ['partner-latitude']: partnerLatitude, ['partner-longitude']: partnerLongitude, partner: localPartner, country, lat, lng,countryName } = localData
  const partner = localPartner;

  const [position, setPosition] = useState();
  const [mapMarkers, setMapMarkers] = useState(markerData);
  const [radius, setRadius] = useState(2);
  const [flyTo, setFlyTo] = useState(false);
  const [outsideClick, setOutsideClick] = useState("");
  const [toggleLocation, setToggleLocation] = useState(false);
  const [location, setLocation] = useState(null);
  const fixedCoordinates = [partnerLatitude, partnerLongitude];
  const [tooltipIndex, setToolTipIndex] = useState("");
  const [hideToolTip, setHideToolTip] = useState("");
  const tooltipRefs = useRef({});

  useEffect(() => {
    if (cancelClick) {
      showAndHideTooltips(true);
    }
  }, [cancelClick]);


  // const SearchComponent = () => {
  //   const map = useMap();
  //   useEffect(() => {
  //     const provider = new OpenStreetMapProvider();
  //     const searchControl = new GeoSearchControl({
  //       provider,
  //       searchLabel: "Search here",
  //       style: "bar", // Search bar style
  //       showMarker: false,
  //       showPopup: false,
  //       autoClose: false, // Keep the result open
  //       keepResult: true, // Keep the search input value
  //       notFoundMessage: "Sorry, that address could not be found.",

  //       marker: {
  //         icon: L.icon({
  //           iconSize: [25, 41],
  //           iconAnchor: [10, 41],
  //           popupAnchor: [2, -40],
  //           iconUrl: true
  //             ? "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png"
  //             : "",
  //         }),
  //       },
  //     });

  //     // Add search control to the map
  //     map.addControl(searchControl);

  //     // Select the input field and cancel button
  //     const searchInput = document.querySelector(
  //       ".leaflet-control-geosearch input"
  //     );
  //     const cancelButton = document.querySelector(
  //       ".leaflet-control-geosearch button"
  //     );

  //     // Reset map when input is cleared or cancel is clicked
  //     const resetMap = () => {
  //       if (searchInput.value === "") {
  //         // Reset map view
  //         map.setView(fixedCoordinates, 6);
  //       }
  //     };

  //     searchInput?.addEventListener("input", resetMap);
  //     cancelButton?.addEventListener("click", resetMap);

  //     map.on("geosearch/showlocation", (event) => {
  //       if (event.location && searchInput) {
  //         const { x, y, label, } = event.location;

  //         const lat = y;
  //         const lng = x;

  //         if (window.currentPopup) {
  //           map.removeLayer(window.currentPopup);
  //         }

  //         // window.currentPopup = L.popup({ closeOnClick: false })
  //         //   .setLatLng([lat, lng])
  //         //   .setContent(`<b>${label}</b>`)
  //         //   .openOn(map);

  //         // setTimeout(() => {
  //         //   if (window.currentPopup) {
  //         //     map.closePopup(window.currentPopup);
  //         //     window.currentPopup = null;
  //         //   }
  //         // }, 5000);

  //         map.on("click", () => {
  //           if (window.currentPopup) {
  //             map.closePopup(window.currentPopup);
  //             window.currentPopup = null;
  //           }
  //         });
  //         searchInput.value = event.location.label;
  //         // map.setView([y, x], 8)
  //         map.setView([y, x], 16);
  //         ;
  //       }
  //     });

  //     return () => {
  //       map.removeControl(searchControl);
  //       searchInput?.removeEventListener("input", resetMap);
  //       cancelButton?.removeEventListener("click", resetMap);
  //     };
  //   }, [map]);

  //   return null;
  // };





const SearchComponent = () => {
  const map = useMap();
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const searchDelay = useRef(null);
  const notFoundTimer = useRef(null);
  const provider = useRef(null);

  useEffect(() => {
    provider.current = new OpenStreetMapProvider();

    const searchControl = new GeoSearchControl({
      provider: provider.current,
      searchLabel: "Search here",
      style: "bar",
      showMarker: true,
      showPopup: false,
      autoClose: false,
      keepResult: true,
      notFoundMessage: "Sorry address not found", // we will show manually

        marker: {
          icon: L.icon({
            iconSize: [25, 41],
            iconAnchor: [10, 41],
            popupAnchor: [2, -40],
            iconUrl: true
              ? "https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png"
              : "",
          }),
        },
    });

    map.addControl(searchControl);

    const input = document.querySelector(".leaflet-control-geosearch input");
    const cancelBtn = document.querySelector(".leaflet-control-geosearch button");

    // ---- Replace cancel icon with loader ----
    const showLoader = () => {
      if (!cancelBtn) return;
      cancelBtn.innerHTML = `
        <span class="loader" 
        style="
          display:inline-block;
          width:16px;
          height:16px;
          border:2px solid #ccc;
          border-top:2px solid #333;
          border-radius:50%;
          animation:spin 0.8s linear infinite;">
        </span>`;
    };

    const showCancel = () => {
      if (!cancelBtn) return;
      cancelBtn.innerHTML = "×";
    };

    // -------- Handle User Typing ----------
    const handleInput = () => {
      const query = input.value.trim();

      // reset states
      setNotFound(false);

      if (query.length === 0) {
        setLoading(false);
        showCancel();
        return;
      }

      setLoading(true);
      showLoader();

      clearTimeout(searchDelay.current);
      clearTimeout(notFoundTimer.current);

      // Debounce search 850ms
      searchDelay.current = setTimeout(async () => {
        try {
          const results = await provider.current.search({ query });

          setLoading(false);
          showCancel();

          if (results && results.length > 0) {
            // ❌ DO NOT auto-select
            // ❌ DO NOT set input.value
            // ❌ DO NOT move map

            setNotFound(false);
            return;
          }

          // No results → delay "not found"
          notFoundTimer.current = setTimeout(() => {
            setNotFound(true);
          }, 1200);

        } catch (err) {
          setLoading(false);
          showCancel();
          setNotFound(true);
        }
      }, 850);
    };

    // ---- User clicks a suggestion (ONLY time we zoom) ----
    map.on("geosearch/showlocation", (event) => {
      const { x, y, label } = event.location;
      setLoading(false);
      setNotFound(false);
      showCancel();

      input.value = label; // update only on click
      map.setView([y, x], 16);
    });

    input?.addEventListener("input", handleInput);
    cancelBtn?.addEventListener("click", () => {
      input.value = "";
      setNotFound(false);
      showCancel();
      map.setView(fixedCoordinates, 6);
    });

    return () => {
      map.removeControl(searchControl);
      input?.removeEventListener("input", handleInput);
    };
  }, [map]);


  // ---- Not Found Message directly under search bar ----
  useEffect(() => {
    const container = document.querySelector(".leaflet-control-geosearch");
    if (!container) return;

    let msgBox = container.querySelector(".not-found-msg");

    if (!msgBox) {
      msgBox = document.createElement("div");
      msgBox.className = "not-found-msg";
      msgBox.style.cssText = `
        color: red;
        font-size: 12px;
        margin-top: 4px;
        margin-left: 4px;
      `;
      container.appendChild(msgBox);
    }

    msgBox.innerText = notFound ? "Sorry, that address could not be found." : "";

  }, [notFound]);

  return null;
};









  useEffect(() => {
    handleMouseOverAndOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapMarkers]);

  const MapEventHandler = () => {
    const map = useMap();
    useMapEvents({
      click: (e) => {
        const popupEl = popupRef.current;
        if (popupEl && !popupEl.contains(e.originalEvent.target)) {
          selectedOrg({});
          setOutsideClick(true);
        } else if (popupEl === null) {
          selectedOrg({});
          setOutsideClick(true);
        }
        setHideToolTip("");
        if (map.getZoom() > 10) {
          showAndHideTooltips(true);
        }
      },
    });
    return null;
  };
  const getPartnerLocation = async () => {
    if (localStorage.getItem("lat") && localStorage.getItem("lng")) {
      const latitude = localStorage.getItem("lat");
      const longitude = localStorage.getItem("lng");
      setPosition([latitude, longitude]);
    } else {
      try {
        const response = await getRequest(
          userapiservice.getPartnerDetails(partner)
        );

        const latitude = response.latitude;
        const longitude = response.longitude;
        setPosition([latitude, longitude]);
        dispatch(setLang(longitude))
        dispatch(setLat(latitude))
      } catch (error) { }
    }
  };

  const showAndHideTooltips = (show = false) => {
    Object.values(markerRefs.current).forEach((markerRef) => {
      if (markerRef) {
        if (show) {
          markerRef?.openTooltip();
        } else {
          markerRef?.closeTooltip();
        }
      }
    });
  };

  const handleLocate = () => {
    // if (toggleLocation) {
    if (false) {
      setLocation(fixedCoordinates); // Set to fixed location
      setFlyTo(false);
      showAndHideTooltips(false);
    } else {
      showAndHideTooltips(false);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation([position.coords.latitude, position.coords.longitude]);
        },
        () => {
          console.log('Unable to fetch your location. Falling back to fixed coordinates.')
          setLocation(fixedCoordinates); // Fallback if location fetch fails
        }
      );
      setFlyTo(true);
    }
    setToggleLocation(!toggleLocation); // Toggle the state
    setOutsideClick(false);
  };

  const ZoomValueHandler = (value) => {
    setRadius(value);
    ChangeRadiusHandler(value);
  };

  useEffect(() => {
    if (radiusValue !== radius) {
      setRadius(radiusValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [radiusValue]);

  useEffect(() => {
    let tempMapMarkers = [];
    markerData.forEach((element, elementIndex) => {
      if (element.addressOutputs && element.addressOutputs.length > 0) {
        element.addressOutputs.forEach((item, index) => {
          tempMapMarkers.push({
            ...item,
            index: elementIndex,
            name: element.name,
            addressOutputs: [element.addressOutputs[index]],
            sectorsOutputs: element.sectorsOutputs,
            carouselLink: element.carouselLink,
            micrositeLogo: element.micrositeLogo,
            businessDescription: element.businessDescription,
            pinColor: "Pink",
            showTooltip: false,
          });
        });
      }
    });

    if (tempMapMarkers.length > 0) {
      setMapMarkers(tempMapMarkers);
    } else {
      setMapMarkers([]);
    }
  }, [markerData]);

  useEffect(() => {
    getPartnerLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (activeMiniPopup?.closePopup) {
      const map = mapRef?.current;
      if (map && typeof map?.closePopup === "function") {
        map?.closePopup();
      }
    }
  }, [activeMiniPopup]);

  const markerOpenPopup = () => {
    if (mapMarkers?.length > 0 && activeMiniPopup?.addressOutputs?.length) {
      const matchingMarker = mapMarkers?.findIndex((item) =>
        item?.addressOutputs?.find(
          (output) => output?.id === activeMiniPopup?.addressOutputs[0]?.id
        )
      );

      const activeMarkerKey = `${mapMarkers[matchingMarker]?.addressOutputs[0]?.latitude}-${mapMarkers[matchingMarker]?.addressOutputs[0]?.longitude}`;
      const activeMarker = markerRefs?.current[activeMarkerKey];

      if (activeMarker) {
        activeMarker?.openPopup();
      }
    }
  };

  function SetViewOnMarker({ markers }) {
    const map = useMap();

    useEffect(() => {
      const latitude = mapMarkers[0]?.addressOutputs[0]?.latitude;
      const longitude = mapMarkers[0]?.addressOutputs[0]?.longitude;

      if (markers?.length === 1) {
        map.setView([latitude, longitude], localStorage.getItem("zoom") || 6);

      } else if (markerData?.length > 1) {
        map.setView(
          [partnerLatitude, partnerLongitude],
          localStorage.getItem("zoom") || 6
        );

      }
      disableSetView();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
  }

  useEffect(() => {
    if (cancelClick) {
      setHideToolTip("");
    }
  }, [cancelClick]);

  useEffect(() => {
    const element = document.querySelector(
      `.leaflet-pane.leaflet-map-pane .leaflet-pane.leaflet-tooltip-pane .leaflet-tooltip.parent.marker-tooltip-${tooltipIndex}`
    );
    if (element) {
      if (hideToolTip) {
        element.classList.add("test_pass");
        handleMouseOverAndOut()
      } else {
        element.classList.remove("test_pass");
        showAndHideTooltips(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideToolTip]);

  const handleMouseOverAndOut = () => {
    const zoom = localStorage.getItem("zoom");
    if (zoom >= 10) {
      showAndHideTooltips(true);
    } else {
      showAndHideTooltips(false);
    }
    return null;
  };

  return (
    <div className="map-container-wrapper">
      {position && markerData ? (
        <MapContainer
          id="map-container"
          className="map-container"
          ref={mapRef}
          center={position}
          zoom={
            localStorage.getItem("zoom") ? localStorage.getItem("zoom") : 10
          }
          scrollWheelZoom={true}
          zoomControl={false}
          ZoomValueHandler={ZoomValueHandler}
          radius={radius}
        >
          <SearchComponent />
          <MyComponent
            ZoomValueHandler={ZoomValueHandler}
            radius={radius}
            showAndHideTooltips={showAndHideTooltips}
            setToolTipIndex={setToolTipIndex}
          />
          <TileLayer
            attribution=""
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <ZoomControl className="zoom-control" position="topright" />
          <LocationMarker targetLocation={location} outsideClick={outsideClick} flyTo={flyTo} />
          {/* {localStorage.getItem("country") === "United Kingdom" && ( */}
          {/* {country === "United Kingdom" && ( */}
            {country === "United Kingdom"  && (

            <Button
              onClick={handleLocate}
              className="locateBtn leaflet-top leaflet-right"
            >
              <img alt='Locate Me' className="locateMeImg" src={locateMe}></img>
            </Button>
          )}

          {mapMarkers?.length > 0 &&
            mapMarkers.map((data, index) => {
              const markerKey = `${data.addressOutputs[0]?.latitude}-${data.addressOutputs[0]?.longitude}`;
              return (
                <>
                  <Marker
                    className="marker-pin"
                    key={`${data.addressOutputs[0]?.latitude}-${data.addressOutputs[0]?.longitude}`}
                    icon={
                      new L.divIcon({
                        // previously companies were color coded wrt sectors
                        html: getMarkerByIndex(data.index),
                        iconAnchor: [25, 55],
                        popupAnchor: [4, -40],
                      })
                    }
                    position={[
                      data.addressOutputs[0]?.latitude,
                      data.addressOutputs[0]?.longitude,
                    ]}
                    data={data}
                    eventHandlers={{
                      click: (e) => {
                        setHideToolTip("hideToolTip");
                        const businessCardPos =
                          e?.target._map.latLngToContainerPoint(e?.latlng);
                        selectedOrg(data, true, businessCardPos);
                        setOutsideClick(true);
                        setToolTipIndex(index);
                        updateCancelClick();
                      },
                      mouseover: (e) => {
                        const zoom = localStorage.getItem('zoom')
                        if (zoom >= 10) {
                          handleMouseOverAndOut(true);

                        }
                      },
                      mouseout: () => handleMouseOverAndOut(),
                    }}
                    ref={(el) => {
                      if (el) {
                        markerRefs.current[markerKey] = el;
                      }
                    }}
                  >
                    <Tooltip
                      style={{ cursor: "default" }}
                      ref={(el) => {
                        if (el) tooltipRefs.current[index] = el;
                      }}
                      id={`leaflet-tooltip-${index}`}
                      key={`${data.addressOutputs[0]?.latitude}-${data.addressOutputs[0]?.longitude}`}
                      direction="top"
                      offset={[0, -50]}
                      data-parent-id={`${index}`}
                      className={`parent marker-tooltip-${index} marker-tooltip 
                        `}
                    >
                      <div
                        style={{ cursor: "default" }}
                        id="myElement"
                        className="tooltip-content"
                        ref={popupRef}
                        data-id={index}
                      >
                        <img
                          className="image-in-tooltip"
                          src={data.micrositeLogo}
                          alt={data.name}
                        />
                      </div>
                    </Tooltip>
                  </Marker>
                </>
              );
            })}
          {mapMarkers?.length > 0 && allowSetView && (
            <SetViewOnMarker markers={mapMarkers} />
          )}
          <MapEventHandler />
        </MapContainer>
      ) : null}
      {activeMiniPopup?.id && markerOpenPopup()}
    </div>
  );
}
